import request from "@/utils/request";

export function apiSeoSiteOptions() {
  return request.get("/seo/siteOptions");
}

export function apiSeoSeedList(params) {
  return request.get("/seo/seedList", params);
}

export function apiSeoSeedDetail(params) {
  return request.get("/seo/seedDetail", params);
}

export function apiSeoSeedAdd(params) {
  return request.post("/seo/seedAdd", params);
}

export function apiSeoSeedEdit(params) {
  return request.post("/seo/seedEdit", params);
}

export function apiSeoKeywordList(params) {
  return request.get("/seo/keywordList", params);
}

export function apiSeoKeywordSiteSummary(params) {
  return request.get("/seo/keywordSiteSummary", params);
}

export function apiSeoKeywordDetail(params) {
  return request.get("/seo/keywordDetail", params);
}

export function apiSeoKeywordAdd(params) {
  return request.post("/seo/keywordAdd", params);
}

export function apiSeoKeywordImport(file) {
  const formData = new FormData();
  formData.append("file", file);
  return request.upload("/seo/keywordImport", formData);
}

export function apiSeoKeywordEdit(params) {
  return request.post("/seo/keywordEdit", params);
}

export function apiSeoSettingGet() {
  return request.get("/seoSetting/get");
}

export function apiSeoSettingSet(params) {
  return request.post("/seoSetting/set", params);
}

export function apiSeoSettingTestConnection() {
  return request.post(
    "/seoSetting/testConnection",
    {},
    { timeout: 120 * 1000 }
  );
}

export function apiSeoSettingWalletBalance() {
  return request.post("/seoSetting/walletBalance", {}, { timeout: 120 * 1000 });
}

export function apiSeoSettingSyncRank(params) {
  return request.post("/seoSetting/syncRank", params);
}

export function apiSeoSettingLiveRank(params) {
  return request.post("/seoSetting/liveRank", params, { timeout: 120 * 1000 });
}

export function apiSeoCostSummary(params) {
  return request.get("/seoCost/summary", params);
}

export function apiSeoApiLogLogs(params) {
  return request.get("/seoApiLog/logs", params);
}

export function apiSeoRankRunList(params) {
  return request.get("/seoRankRun/runs", params);
}

export function apiSeoRankRunPlan(params) {
  return request.get("/seoRankRun/plan", params);
}

export function apiSeoRankRunHealth() {
  return request.get("/seoRankRun/health");
}

export function apiSeoRankCleanupPreview(params) {
  return request.get("/seoRankRun/cleanupPreview", params);
}

export function apiSeoRankTimeline(params) {
  return request.get("/seoRankRun/timeline", params);
}

export function apiSeoRankCurrentExecution(params) {
  return request.get("/seoRankRun/currentExecution", params);
}

export function apiSeoRankCycleList(params) {
  return request.get("/seoRankRun/cycles", params);
}

export function apiSeoRankCycleSiteList(params) {
  return request.get("/seoRankRun/cycleSites", params);
}

export function apiSeoRankCycleDetail(params) {
  return request.get("/seoRankRun/cycleDetail", params);
}

export function apiSeoRankCycleTimeline(params) {
  return request.get("/seoRankRun/cycleTimeline", params);
}

export function apiSeoRankCommandRunList(params) {
  return request.get("/seoRankRun/commandRuns", params);
}

export function apiSeoRankAutoRunList(params) {
  return request.get("/seoRankRun/autoRuns", params);
}

export function apiSeoRankBatchList(params) {
  return request.get("/seoRankRun/batches", params);
}

export function apiSeoRankAutoBatchList(params) {
  return request.get("/seoRankRun/autoBatches", params);
}

export function apiSeoRankRunTaskList(params) {
  return request.get("/seoRankRun/tasks", params);
}

export function apiSeoRankAutoTaskList(params) {
  return request.get("/seoRankRun/autoTasks", params);
}

export function apiSeoRankRetryTask(params) {
  return request.post("/seoRankRun/retryTask", params);
}

export function apiSeoRankRetryBatch(params) {
  return request.post("/seoRankRun/retryBatch", params);
}

export function apiSeoRankResubmitBatch(params) {
  return request.post("/seoRankRun/resubmitBatch", params);
}

export function apiSeoRankManualCollect(params) {
  return request.post("/seoRankRun/manualCollect", params);
}

export function apiSeoRankReconcileUnknown(params) {
  return request.post("/seoRankRun/reconcileUnknown", params, {
    timeout: 300 * 1000,
  });
}

export function apiSeoRankResumeCycle(params) {
  return request.post("/seoRankRun/resumeCycle", params);
}

export function apiSeoRankForceCloseCycle(params) {
  return request.post("/seoRankRun/forceCloseCycle", params);
}

export function apiSeoRankAbandonUnknown(params) {
  return request.post("/seoRankRun/abandonUnknown", params);
}

export function apiSeoRankRepairPreview(params) {
  return request.get("/seoRankRun/repairPreview", params);
}

export function apiSeoRankRepairFailed(params) {
  return request.post("/seoRankRun/repairFailed", params, {
    timeout: 300 * 1000,
  });
}

export function apiSeoRankRetryRun(params) {
  return request.post("/seoRankRun/retryRun", params);
}

export function apiSeoRankResubmitRun(params) {
  return request.post("/seoRankRun/resubmitRun", params);
}

export function apiSeoReportSnapshots(params) {
  return request.get("/seoReport/snapshots", params);
}

export function apiSeoDashboardSummary() {
  return request.get("/seoDashboard/summary");
}

export function apiSeoEffectReportDetail(params) {
  return request.get("/seoEffectReport/detail", params);
}

export function apiSeoEffectReportEditorOptions(params) {
  return request.get("/seoEffectReport/editorOptions", params);
}

export function apiSeoEffectReportEditorDetail(params) {
  return request.get("/seoEffectReport/editorDetail", params);
}

export function apiSeoEffectReportRefresh(params) {
  return request.post("/seoEffectReport/refreshLocal", params);
}

export function apiSeoEffectReportSave(params) {
  return request.post("/seoEffectReport/saveDraft", params);
}

export function apiSeoEffectReportPublish(params) {
  return request.post("/seoEffectReport/publish", params);
}

export function apiSeoEffectReportExport(params) {
  return request.get("/seoEffectReport/exportData", params);
}
